import Dialog from "../../General/ConfirmableDialog";
import axios from "axios";
import useAuth from "../../../hooks/useAuth";
import {
  apiVariable } from "../../../api/apiVariable";
import { useQuery } from "@tanstack/react-query";
import {
  Box,
  CircularProgress,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const fetchSettlementPayeeInfo = async (
  token: string | null | undefined,
  code: string
) => {
  const { data } = await axios.get(
    `${apiVariable}/getSettlementPayeeInfo/${code}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return data;
};

const SettlementPayeeInfoModal = ({
  payTo,
  open,
  onClose,
}: {
  payTo: string;
  open: boolean;
  onClose: () => void;
}) => {
  const { token } = useAuth();

  const {
    data: settlementPayeeInfo,
    isLoading,
    isError,
    error,
  } = useQuery({
    queryKey: ["settlementPayeeInfo"],
    queryFn: () => fetchSettlementPayeeInfo(token, payTo),
    enabled: open,
  });

  return (
    <>
      <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
        <DialogTitle>
          <Box className="shop-details-header">
            <Typography variant="h6">Settlement Payee Info</Typography>
            <IconButton onClick={onClose} className="close-icon">
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent>
          {isLoading ? (
            <Box className="table-loader">
              <CircularProgress />
            </Box>
          ) : isError ? (
            <Box className="table-error">
              <Typography color="error">
                Error: {(error as any).message}
              </Typography>
            </Box>
          ) : payTo ? (
            <Box>
              <Typography>Company Name: {settlementPayeeInfo?.name}</Typography>
              <Typography>Address: {settlementPayeeInfo?.address}</Typography>
              <Typography>City: {settlementPayeeInfo?.city}</Typography>
              <Typography>
                State: {settlementPayeeInfo?.state.toUpperCase()}
              </Typography>
              <Typography>Zip Code: {settlementPayeeInfo?.zipCode}</Typography>
              <Typography>
                Phone number: {settlementPayeeInfo?.phoneNumber}
              </Typography>
              <Typography>
                Email: {settlementPayeeInfo?.emailAddress}
              </Typography>
            </Box>
          ) : (
            <Typography>No settlement payee info found</Typography>
          )}
        </DialogContent>
      </Dialog>
    </>
  );
};

export default SettlementPayeeInfoModal;
